import { render, staticRenderFns } from "./case-data.vue?vue&type=template&id=31b04dd0&"
import script from "./case-data.vue?vue&type=script&lang=js&"
export * from "./case-data.vue?vue&type=script&lang=js&"
import style0 from "./case-data.vue?vue&type=style&index=0&id=31b04dd0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports